export const collegeNames = [
  "Elphinston College",
  "Kishinchand Chellaram College",
  "H R College of Commerce And Economics",
  "Siddharth College of Com and Economics Anand Bhavan",
  "Siddharth College of Arts Science and Commerce Buddha Bhavan Fort Mumbai",
  "Jai Hind College",
  "Sydenham College of Commerce and Economics",
  "K. P. B. Hinduja College of Commerce",
  "Bhavans Hazarimal Somani college",
  "NSS College of Commerce and Economics ",
  "Wilson College, Mumbai",
  "Sophia College Autonomous ",
  "Lala Lajpat Rai College of Commerce and Economics,  Mumbai",
  "Sant Gadge Maharaj College of Commerce and Economics",
  "A.P.College",
  "Dr. T.K. Tope Night College, Parel",
  "Maharshi Dayanand College ",
  "Kirti M.Doongursee College ",
  "D.G.Ruparel College of Arts,Science and Commerce",
  "Ramnarain Ruia Autonomous College, Matunga, Mumbai",
  "R A Podar College of Commerce and Economics Autonomous",
  "Dr. Ambedkar College of Comm. and Eco.,Wadala, Mumbai",
  "S.I.W.S. N. R. Swamy College of Commerce and Smt. Thirumalai College of Science",
  "G. N. Khalsa College (Autonomous) Matunga 19",
  "SIES College of Arts, Science and Commerce Sion, Mumbai 400022",
  "SIES College of Commerce and Economics, Sion East",
  "Gurunanak College, GTB Nagar",
  "Vidyalankar School of Information Technology",
  "Institute of Forensic Science",
  "PVPPCOE",
  "Government Law College, Churchgate, Mumbai - 400020",
  "Chetanas H.S.College of Commerce and Economics Bandra Mumbai ",
  "Rizvi College of Arts Science and Commerce Bandra West ",
  "St. Andrews College of Arts, Science and Commerce",
  "Smt. MMK College of Commerce and Economics",
  "Rishi Dayaram and Seth Hassaram National College and Seth Wassiamull Assomul Science College, Bandra",
  "Thadomal Shahani Engineering College",
  "Fr. Conceicao Rodrigues College of Engineering",
  "Mahendra Pratap Sharda Prasad Singh College of Arts Science and Commerce ",
  "L.S. Raheja College of Arts And Commerce",
  "Patuck  Gala College of Commerce and Management",
  "Public Night Degree College",
  "Sathaye college",
  "PTVAs M.L.Dahanukar College of Commerce,Vile Parle",
  "SVKMS Mithibai College",
  "N M College of Commerce and Economics",
  "Dwarkadas J Sanghavi College of Engineering",
  "Bhavans college Andheri ",
  "Valia C.L.College of Commerce",
  "Smt. PDD Tibrewala Lions Juhu College of Arts Commerce and Science",
  "Government of Maharashtra Ismail Yusuf college",
  "Claras College of Commerce ",
  "Vivek College of Commerce",
  "Jashbhai Maganbhai Patel College Of Commerce",
  "S.S. and L.S. Patkar and V.P. Varde college Goregaon ",
  "Prahladrai Dalmia lions college of Commerce and Economics ",
  "Ghanshyamdas Saraf College of Arts and Commerce ",
  "Nagindas Khandwala College of Commerce ,Arts and Management Studies and Shantiben Nagindas Khandwala",
  "D.T.S.S.College of Commerce",
  "Smt. K. G. Mittal College of Arts and Commerce, Malad  ",
  "Balbharatis MJP College of Commerce ",
  "KES Shroff college of Arts and Commerce ",
  "Thakur College of Science and Commerce",
  "Thakur College of Engineering and Technology ",
  "Niranjana Majithia College of Commerce",
  "GESs Shri Bhausaheb Vartak Arts Commerce and Science College Borivali West Mumbai",
  "A D Kale College Borivali",
  "Shailendra Education Societys Arts, Commerce and Science College",
  "Smt. Kamala Mehta V. W. A College of Commerce ",
  "M.K.Sanghvi College of Commerce and Economics",
  "Prakash Degree College of Commerce and Science",
  "Bunts Sanghas, S M Shetty College of Science Commerce and Management studies ",
  "Chandrabhan Sharma college of Arts Science and Commerce",
  "SVKMs Usha Pravin Gandhi College of Arts, Science and Commerce",
  "Nirmala Memorial Foundation College",
  "Vidya Vikas College of Arts, Science, Commerce, BMM and BMS",
  "Matushri Pushpaben Vinubhai Valia College of Commerce",
  "Kaiser college of Commerce",
  "Atharva College Of Engineering",
  "M.V.Mandalis Colleges of Commerce and Science ",
  "LN College",
  "Mumbai University Kalina campus Unit",
  "N.G. Acharya and D.K. Marathe College",
  "V. E. S. College of Arts, Science and Commerce, Chembur",
  "Mahatma Night Degree College of Arts and Commerce, Chembur",
  "Sree Narayana Guru College of Commerce",
  "Don Bosco Institute of Technology Kurla",
  "K.J.Somaiya College of Arts and Commerce, Vidyavihar",
  "K.J.Somaiya college of Science and Commerce.",
  "S.K Somaiya college of Arts,Science and Commerce",
  "Ramniranjan Jhunjhunwala College of Arts Science and Commerce",
  "Gurukul College of Commerce Ghatkopar",
  "Asmita College of Arts and Commerce for Women ,Vikhroli",
  "Vikas College of Arts, Science and Commerce, Vikhroli.",
  "Sandesh College of Arts , Commerence and Science Vikhroli East ",
  "Rajiv Gandhi Night College (vikhroli)",
  "V.K.Krishna Menon College of Commerce and Economics and S.S.Dighe College of Science",
  "Ramanand Arya DAV College",
  "NES Ratnam College",
  "Mulund College of Commerce ",
  "KETs V. G. Vaze College of Arts, Science and Commerce ",
  "Jai bharat college of Commerce mulund night college mulund ",
  "VPMs R Z SHAH COLLEGE OF Arts , Science and Commerce ",
  "Don Bosco College BMSHS,BMM",
  "Shri Ram College of Commerce ",
  "Laxmichand Golwala college of Commerce and Economics, Ghatkopar ",
  "Royal College of Arts, Science and Commerce",
  "Shankar Narayan college of Arts and Commerce Bhayander ",
  "Abhinav college",
  "Reena Mehta College",
  "St.Joseph Senior College of Arts and Commerce Uttan Bhayander",
  "Gramin shikshan Sanstha Arts and Com College Nahi Wada Thane",
  "Dnyanganga Education Trust Degree College Thane west",
  "Sheth N.K.T.T.College Thane",
  "VPMs Joshi Bedekar College,Thane",
  "K B College of Arts and Commerce for Women, Thane",
  "B.N.Bandodkar College of Science,Thane",
  "Satish Pradhan Dnyanasadhana College Thane",
  "R. J. Thakur Degree College of Arts and Commerce, Thane ",
  "Smt.Janakibai Rama Salvi College Kalwa West Thane",
  "A.E. Kalsekar Degree College Mumbra",
  "M.S College of Arts, Sci, Com and BMS",
  "DSPMs K. V. Pendharkar college of Arts, Science and Commerce",
  "Model College, Dombivli",
  "The S.I.A College of Higher Education, Dombivli ",
  "Pragati College of Arts and Commerce, Dombivli",
  "Royal college of Science and Commerce , dombivli",
  "Swami Vivekanand Night College of Arts and Commerce, Dombivli ",
  "KSs Manjunatha College of Commerce, Thakurli",
  "JMFs Vande mataram Degree college of Arts , Commerece and Science ( CS and IT ) ",
  "BNN College Bhiwandi",
  "K.M.E.Societys G.M.Momin Womens College ",
  "Samadiya College of Arts and Commerce Bhiwandi ",
  "CSM Arts and Commerce College, Padgha ",
  "Mahendra Laxman Mhatre Degree College",
  "Saket College of Arts,Science,Commerce",
  "Samyak Sankalpa College Kalyan East ",
  "Model College, Kalyan",
  "Ideal College of Pharmacy and Research, Kalyan",
  "B.K.Birla College Kalyan",
  "Laxman Devram Sonawane College,Kalyan",
  "Seth Hirachand Mutha college of Arts,Commerce and Science,Kalyan",
  "Mohindar Singh Kabal Singh Degree College, Kalyan ",
  "K.M.Agrawal College",
  "Matoshree  Velbai  Devji  Hariya  College, Shahad ",
  "Kamaladevi College",
  "R K Talreja College",
  "Smt. CHM College, Ulhasnagar",
  "J. W. Sadhubella Girls College",
  "SST College of Arts and Commerce, Ulhasnagar",
  "SES Swami Hansmuni Maharaj Degree College of Commerce, Ulhasnagar",
  "P. D. Karkhanis College Ambernath",
  "SICES Degree College of Arts, Commerce and Science, Ambarnath",
  "Adarsh College Badlapur",
  "Bharat College of Arts and Commerce",
  "JSSPs  A.C.S College Goveli",
  "Shantarambhau Gholap Arts, Science and G. Pawar Commerce college, Shivle",
  "J.P.College Tokawade",
  "Sonubhau Baswant College of Arts and Commerce, Shahapur",
  "Arts, Commerce and Science College, Kinhavali",
  "Bhimrao T Pradhan College, Shahapur",
  "JSSP Arts Commerce and Science College Khardi",
  "Utkarsha College Vashind",
  "Karmaveer Bhaurao Patil College Vashi Navi Mumbai",
  "ICLEs Motilal Jhunjhunwala College",
  "Western College of Commerce and Business Management",
  "Rajiv Gandhi College Arts, Commerce and Science Vashi Navi mumbai",
  "SIES Nerul College of Arts Science and Commerce",
  "SIES Graduate School of Technology, Nerul",
  "Sterling College of Arts Commerce and Science ",
  "Ramsheth Thakur College of Commerce and Science",
  "JVMs Mehta Degree College, Airoli ",
  "Smt. Sushiladevi Deshmukh College of Arts, Science and Commerce. Airoli",
  "D.V.S. COLLEGE OF Commerce ",
  "F.G. Naik College of Arts, Science IT and Commerce",
  "Konkan Gyanpeeth Uran College of Commerce and Arts,Uran",
  "Veer Wajekar A.S.C. College, Phunde Uran",
  "Mahatma Phule Arts,Science and Commerce College,Panvel ",
  "C.K.T. A.C.S. College, New Panvel Autonomous",
  "Pillai college of Arts Commerce and Science Autonomous New Panvel",
  "Shikshan Maharshi Dadasaheb Limaye College Kalamboli",
  "PESs Bhaiusaheb Nene ASC College Pen Raigad",
  "Dr Patangrao Kadam Arts and Commerce College Pen",
  "KES Anandibai Pradhan Science College, Nagothane",
  "Vasantrao Naik College Murud Janjira Raigad",
  "MSPMs D.G.Tatkare Mahavidyalay, Mangaon",
  "Tikambhai Metha Commerce College ",
  "Doshi Vakil Arts College and G.C.U.B Sci andCom College Goregaon",
  "Konkan Gyanpeeth, Karjat College Of A.S.C.,Karjat",
  "KMC College Khopoli",
  "KES Laxmi Shalini ACS Womens College Pezari  ",
  "J. S. M. College, Alibag ",
  "PPES ACS College, Veshvi Alibag",
  "Sheth J.N.Paliwala College Pali",
  "Dr.C.D.Deshmukh College,Roha",
  "D G Tatkare Arts and Commerce College",
  "Vasantrao Naik College Mhasla Raigad",
  "Dr. Babasaheb Ambedkar College, Mahad",
  "Sundarrao More Arts,Commerce andScience College Poladpur",
  "GES Arts Commerce and Science College Shreewardhan, Raigad.",
  "Dr A R Undre Womens Degree College of Sc,Com, Arts",
  "Matoshree Sumati Chintamani Tipnis College of Arts and Commerce Neral ",
  "KSA Barns College of ASC, Panvel",
  "Dr. Shree Nanasaheb Dharmadhikari A.C.S College Kolad",
  "G. M. Vedak College of Science",
  "Pillai HOC college of Arts Science and Commerce, Rasayani",
  "N.K.Vardkar Arts and R.V.Belose Commerce college,Dapoli",
  "Dapoli Education Societys Dapoli Urban Bank Senior Science College Dapoli",
  "I.C.S. College of Arts, Commerce and Science, Khed",
  "T.B.K.college Bharne ",
  "Arts and Science College Sawarde ",
  "D.B.J. College Chiplun",
  "Dr.Tataysaheb Natu College of Arts and senior college of Commerce margtamhane Tal.chiplun Dist.Ratna",
  "G B tatha Tatyasaheb Khare Com, P G Dhere Arts and Shri M J Bhosale Sci College, Guhagar",
  "Arts and Commerce College,Sakharpa",
  "ASP (Autonomous) College, Devrukh",
  "R. P. Gogate And R. V. Jogalekar College Ratnagiri",
  "S.P.Hegshetye College of Arts,  Commerce, Science,  Ratnagiri",
  "Arts,Commerce and Science College,Lanja",
  "L G M Arts Commerce and Science college Mandangad",
  "Abasaheb Marathe Arts and New Commerce Science  College, Rajapur ",
  "Shri M H K Arts and Com. College Pachal Ratnagiri",
  "Patpanhale Arts Commerce and Science College",
  "Gharda Institute of Technology",
  "PSPSs Indira Institute of Pharmacy, Sadavali, Devrukh.",
  "D. J. Samant Senior College of Arts, Commerce and Science",
  "Loknete Shamraoji Peje Arts Commerce Science Mahavidyalay Shiwar Ambere Ratnagiri",
  "Mohini Murari Mayekar Arts and Commerce College Chafe",
  "Chhatrapati Rajarshi Shahu Maharaj Sr. College,Tetawali ",
  "Dnyandeep College of Science and Commerce, Morvande Boraj, Khed",
  "RamRaje College, Dapoli ",
  "Rajendra Mane College of Engineering and Technology Ambav ",
  "Shri. S. H. Kelkar Arts Commerce and Science College Devgad",
  "Kankavli College, Kankavli",
  "Arts And Commerce College Phondaghat",
  "S K Patil College Malvan",
  "Sant Rawool Maharaj Mahavidyalya, Kudal",
  "Arts Commerce and Science college Oros ",
  "Br. Balasaheb Khardekar College Vengurla",
  "Anandibai Raorane Arts, Commerce and Science College, Vaibhavwadi",
  "Gogate Walke College Banda Sindhudurg ",
  "SPK  College,Sawantwadi",
  "NSSs L S Halbe College of Arts Commerce and Science Dodamarg",
  "Dr.J.B.Naik Arts and Commerce College,Sawantwadi",
  "Arts and Commerce College Talere",
  "P. Pu. Vinayak Anna Rawool Maharaj Mahavidyalay Salgaon",
  "Annasaheb Vartak College,Vasai Road West",
  "St Gonsalo Garcia College of Arts and Commerce Vasai",
  "St. Joseph College of Arts and Commerce, Satpala, Virar(west)",
  "VIVA College of Arts Commerce and Science",
  "Sonopant Dandekar College, Palghar ",
  "Dnyan Bharti Societys Sau. S. R. Karandikar College",
  "Shri. P. L. Shroff College, Chinchani",
  "G. E. Societys N. B. Mehta Science College, Bordi",
  "Com.Godavari Shamrao Parulekar College,Talasari",
  "Dr. S.D.D. Arts College and Commerce and Science College Wada",
  "GESs Arts Commerce and Science College Jawhar",
  "Arts Commerce and Science College Onde ",
  "Rayat Shikshan Sansthas Arts, Science and Commerce College, Mokhada",
  "A. E. Kalsekar College of Commerce and Management Nallasopara ",
  "St.John college of Engineering and Management , Palghar",
  "Wada College of Management and Science",
  "M N M Guruji Art, Commerce and BMS College, Khodala- Jogalwadi",
  "Yeshwantrao Chaphekar college of Commerce and Management",
  "Maharashtra College of Arts, Science and Commerce ",
  "College of Home Science Nirmala Niketan ",
  "K.J Somaiya institute of Engineering and IT Sion Mumbai",
  "Vidyalanakar Institute of Technology ",
  "Adv. Balasaheb Apte College of Law",
  "Xavier Institute of Engineering",
  "NKES College of Arts Commerce and Science",
  "Nirmala College of Commerce ",
  "St Rocks Degree College of Commerce and Science",
  "St. Francis Institute of Technology Borivili ",
  "Ladhidevi Ramdhar Maheshwari Night College ",
  "Lords Universal College",
  "Ghanshyamdas Jalan College",
  "Sheila Raheja School of Business Management and Research ",
  "Nirmal Degree College of Commerce Kandivali",
  "Rizvi College of Engineering Bandra West ",
  "Shri GPM Degree College of Science and Commerce ",
  "Atharva college of hotel management and Catering technology",
  "Thakur Ramanarayan College of Arts and Commerce",
  "Nalanda College of Arts, comm., Sci.",
  "JES college of Commerce Science and IT",
  "Nava Samaj Mandal Degree College",
  "Lords Universal Collge of Law ",
  "Adv. V. B. Deshpande College of Commerce ( Night ) Mulund - W",
  "Indira Gandhi College Of Arts and Commerce,Vikhroli west",
  "Anna Leela College Kurla",
  "Bhavana Trust College of Commerce and B.Sc. Computer Science",
  "Vidyaniketan Degree College of Commerce",
  "Pune Vidyarthi Grihas College of Science and Technology",
  "Terna Engineering College",
  "GKS Arts Com and Sci. Khadavali  ",
  "Achievers College of Commerce and Management, Kalyan",
  "Vedanta College Vithalwadi",
  "St. Paul College",
  "Shri Mahadev Baburav Chaughule college Rahnal Bhiwandi ",
  "Bharati Vidyapeeth College of Engineering",
  "GIFs Shree Jaya Anand Degree Night College",
  "Mat.K.M.Patel Sr.College of Commerce and Science, Thakurli  (E)",
  "AVMs Karmaveer Bhaurao Patil Degree College",
  "Anand Vishwa Gurukul Senior Night College, Thane",
  "Saraswati College Of Engineering Kharghar ",
  "S. K. College of Sci and Comm, Nerul",
  "Seva Sadans College of Education",
  "Seva Sadan College of Arts, Science and Commerce ",
  "Mansi Bharat Gada Degree College of Commerce ",
  "Shree L R Tiwari College of Engineering",
  "Siddharth College Boradpada",
  "Lokmanya Tilak College of Engineering,Navimumbai.",
  "Alamuri Ratnamala Institute of Engineering and Technology",
  "Swayam Siddhi Degree College Bhiwandi.",
  "Datta Meghe College of Engineering",
  "A C Patil College of Engineering ",
  "K.C. College of Engineering and Management Studies and Research",
  "Shivaji Rao.S.Jondhle College of engineering and technology, Asangaon",
  "Sahyog college of Management studies",
  "Shree L. R. Tiwari Degree College of Arts, Commerce and Science, Miraroad",
  "N.L.Dalmia college of Arts, Commerce and Science, Mira Road",
  "A. P. Shah Institute of Technology",
  "Shivajirao S Jondhle College of Pharmacy, Asangaon",
  "Jeevandeep Arts Commerce and Science College Mhasa Murbad",
  "FR. C. RODRIGUES INSTITUTE OF TECHNOLOGY, VASHI",
  "Smt Indira Gandhi College of Engineering Ghansoli",
  "Ramrao Adik Institute of Technology, Nerul Navi Mumbai ",
  "G V Acharya Institute of Engineering and Technology Shelu",
  "Konkan Gyanpeeth College of Engineering, Karjat",
  "M.B.More foundations Arts Commerce and Science Women College Dhatav Roha Raigad Maharashtra India",
  "LSPMs ASC Sr.College Chondhi-kihim",
  "KLE Societys Science AND Commerce COLLEGE, KALAMBOLI",
  "Anjuman Islam Janjira Degree College of Science Murud janjira Raigad",
  "Hirwal Education Trusts College of CSIT, Mahad-Raigad",
  "G. M. Vedak Institute of Technology, Tala",
  "Uran Education Societys College of Management and Technology Bori Uran",
  "Pillai HOC College of Engineering and Technology, Rasayani",
  "M.M Jagtap Arts Commerce and Science sr College Mahad Raigad",
  "Vishwaniketans Institute of Management Enterprenuarship and Engineering Khumbhivali",
  "MESs Pillai College of Engineering, New Panvel",
  "SV COLLEGE of Arts Commerce and Science Taloja Dist Raigad",
  "NSS college of Arts Commerce and Science Sangameshwar",
  "Dr. Tanajirao Chorage Sr. College of Arts and Commerce, Mandki Palvan",
  "VPMs Maharishi Parashuram college of engineering Velneshwar",
  "VBDBA  Model College Ambadave mandangad",
  "Sou. Shailaja shinde Arts Commerce and Science senior college Pedhambe",
  "Pujya Sane Guruji Arts and Commerce Sr. College,Palgad",
  "BSM Senior College Ratnagiri",
  "Govindrao Nikam college of pharmacy, Sawarde",
  "Finolex Academy of Management and Technology Ratnagiri",
  "Arts and Commerce College, Phanasgaon",
  "Br Nath Pail Shikshan Sanths Womens College",
  "Arts, Commerce and Science College, Kharepatan",
  "Dr Dadasaheb Waradkar Arts and Commerce College Katta",
  "Achara College of Management Studies, Achara",
  "Vijayalakshmi Vishwanath Dalvie College",
  "P B Vengurlekar Mahavidyalaya Pandurtitha Kudal",
  "St. John Institute of Pharmacy and Research Palghar ",
  "Sahyadri Shikshan Seva Mandals Arts and Commerce College",
  "Dr. Babasaheb Ambedkar College",
  "St. John College of Humanities and Sciences,Palghar",
  "Smt D M Chavan College Silvasa",
  "VIVA Institute of Pharmacy,Virar",
  "Universal College of Engineering ",
  "Ideal Institute of Pharmacy Wada",
  "Theem College of Engineering, Boisar",
  "Vidyavardhinis College of Engineering andTechnology,,Vasai West",
  "M.S.College of Pharmcay, devghar",
  "VIVA Institute of Technology",
];
